<template>
  <v-expansion-panel :class="$style['base-accordion']">
    <v-expansion-panel-header>
      <slot name="header"></slot>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot name="body"></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'BaseAccordion',
}
</script>

<style lang="scss" module>
.base-accordion {
  :global(.v-expansion-panel) {
    border-bottom: 1px solid var(--primary) !important;

    :global(.v-icon--svg) {
      color: var(--primary) !important;
    }
  }
}
</style>
